//#region imports
import customAxios from '../../utils/customAxios';
import React, { useState, useEffect, useCallback } from 'react';

import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';

import { useNavigate } from 'react-router-dom';
import { Tooltip } from '@mui/material';

import { Stack } from '@mui/system';
import ModalVTDelete from '../Modal/Delete/ModalVTDelete';
import ModalVTUpdate from '../Modal/Update/ModalVTUpdate';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAdd,
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
} from '@fortawesome/free-solid-svg-icons';

import { DeleteOutlineOutlined as DeleteIcon } from '@mui/icons-material';

import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';

import { useTranslationHook } from '../../hooks/UseTranslationHook';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { GlobalVariables } from '../../globalVar';
import ModalVT from '../Modal/Create/ModalVT';
import VTypesDetailPanel from '../MasterDetails/VTypesDetailPanel';
import { useTableLocale } from '../../hooks/useTableLocale';

library.add(
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble
);

//#endregion

export const ConfigVisitTypes = () => {
  // Config de hooks
  const [configVTypesData, setConfigVTypesData] = useState([]);
  const [modalVTShow, setModalVTShow] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const { t } = useTranslation();

  const {
    vTypesNameString,
    vTypesDescString,
    vTypesStatusString,
    noVtypesString,
    loadingString,
    detailString,
    editString,
    deleteString,
    addVtypeString,
  } = useTranslationHook();

  useEffect(() => {
    const updateCVTypeData = () => {
      setConfigVTypesData((prevData) => {
        return prevData.map((vtype) => ({
          ...vtype,
          is_active: t(`${vtype.is_active}`),
        }));
      });
    };
    i18next.on('languageChanged', updateCVTypeData);

    return () => {
      i18next.off('languageChanged', updateCVTypeData);
    };
  }, [t]);

  const endpoint = `${GlobalVariables.getURL()}listVisitTypes`;

  const getData = async () => {
    setIsLoading(true);

    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      const configVTypesData = response.data.map((vtype) => {
        return {
          ...vtype,
          is_active: t(`${vtype.is_active}`),
        };
      });
      setConfigVTypesData(configVTypesData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    // No necesitas hacer nada en este efecto.
  }, [isLoading]);

  const navigate = useNavigate();
  const [modalVTDeleteShow, setModalVTDeleteShow] = useState(false);

  function manageConfigVTypeDelete(visitTypeInfo) {
    var vTypeId = visitTypeInfo.id;
    localStorage.setItem('visitTypeIdToDelete', vTypeId);

    var vTypeName = visitTypeInfo.vt_name;
    var vTypeDesc = visitTypeInfo.description;

    localStorage.setItem('vTypeNameToDelete', vTypeName);
    localStorage.setItem('vTypeDescToDelete', vTypeDesc);
  }

  const [modalVTUpdateShow, setModalVTUpdateShow] = useState(false);

  function manageConfigVTypeUpdate(visitTypeInfo) {
    return new Promise((resolve, reject) => {
      var visitTypeId = visitTypeInfo.id;
      localStorage.setItem('visitTypeIdForUpdate', visitTypeId);

      customAxios
        .get(`${GlobalVariables.getURL()}autofillVisitType/${visitTypeId}`, {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        })
        .then((response) => {
          var visitTypeData = response.data;
          var vtNameForUpdate = visitTypeData.vt_name;
          localStorage.setItem('vtNameForUpdate', vtNameForUpdate);
          var vtDescForUpdate = visitTypeData.description;
          localStorage.setItem('vtDescForUpdate', vtDescForUpdate);
          var vtEstimatedDurationForUpdate = visitTypeData.estimated_duration;
          localStorage.setItem(
            'vtEstimatedDurationForUpdate',
            vtEstimatedDurationForUpdate
          );
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  const actionColumn = [
    {
      field: 'action',
      headerName: detailString,
      width: 160,
      renderCell: (params) => {
        return (
          <div className='cellAction'>
            <Tooltip title={editString} arrow>
              <button
                type='button'
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  marginTop: '5px',
                }}
                onClick={async () => {
                  try {
                    await manageConfigVTypeUpdate(params.row);
                    setModalVTUpdateShow(true);
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                <ModeEditOutlineOutlinedIcon
                  className='detail-icons'
                  id='update-icon'
                />
              </button>
            </Tooltip>
            <Tooltip title={deleteString} arrow>
              <button
                type='button'
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  marginTop: '5px',
                }}
                onClick={() => {
                  setModalVTDeleteShow(true);
                  manageConfigVTypeDelete(params.row);
                }}
              >
                <DeleteIcon className='detail-icons' id='delete-icon' />
              </button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  // Columnas
  const configVTypesColumns = [
    {
      field: 'vt_name',
      headerName: vTypesNameString,
      width: 200,
    },
    {
      field: 'description',
      headerName: vTypesDescString,
      width: 380,
    },
    {
      field: 'is_active',
      headerName: vTypesStatusString,
      width: 110,
      renderCell: (params) => {
        if (
          params.row.is_active === 'Activo' ||
          params.row.is_active === 'Active'
        ) {
          return (
            <div>
              <span className='statusActive'>{params.row.is_active}</span>
            </div>
          );
        } else {
          return (
            <div>
              <span className='statusInactive'>{params.row.is_active}</span>
            </div>
          );
        }
      },
      valueGetter: (params) => params.row.is_active,
    },
    // Map through all columns and add default renderCell if not already defined
  ].map((col) =>
    col.renderCell
      ? col
      : {
          ...col,
          renderCell: (params) =>
            params.row[col.field] ? params.row[col.field] : '-',
        }
  );

  const getDetailPanelContent = useCallback(
    ({ row }) => <VTypesDetailPanel row={row} />,
    []
  );

  const getDetailPanelHeight = useCallback(() => 250, []);

  const locale = useTableLocale();

  return (
    <div className='full-container'>
      <div className='full-datatables-container'>
        <div style={{ marginTop: '1%', marginBottom: '1%' }}>
          <button className='add-button' onClick={() => setModalVTShow(true)}>
            {addVtypeString} <FontAwesomeIcon icon={faAdd} />
          </button>
        </div>
        <ModalVT
          show={modalVTShow}
          onHide={() => setModalVTShow(false)}
          getVisitTypesData={getData}
        />

        <ModalVTDelete
          show={modalVTDeleteShow}
          onHide={() => setModalVTDeleteShow(false)}
          getVisitTypesData={getData}
        />

        <ModalVTUpdate
          show={modalVTUpdateShow}
          onHide={() => setModalVTUpdateShow(false)}
          getVisitTypesData={getData}
        />

        <DataGridPro
          pagination
          loading={isLoading}
          initialState={{
            sorting: {
              sortModel: [{ field: 'id', sort: 'desc' }],
            },
            columns: {
              columnVisibilityModel: {
                id: false,
              },
            },
            pinnedColumns: { right: ['action'] },
          }}
          rows={configVTypesData}
          columns={configVTypesColumns.concat(actionColumn)}
          pageSize={10}
          disableSelectionOnClick
          slots={{
            noRowsOverlay: () => (
              <Stack height='100%' alignItems='center' justifyContent='center'>
                {noVtypesString}
              </Stack>
            ),
            // toolbar: GridToolbar,
          }}
          getDetailPanelHeight={getDetailPanelHeight}
          getDetailPanelContent={getDetailPanelContent}
          localeText={locale.components.MuiDataGrid.defaultProps.localeText}
        />
      </div>
    </div>
  );
};
